import { Component, OnInit, Inject } from '@angular/core';
import { Validators, FormBuilder } from '@angular/forms';

import * as Services from '@shared/core/services';
import * as Tokens from '@shared/core/tokens';
import { Controllers } from '@shared/core/controllers';

import { FormTypesComponent } from '../form-types.shared.component';
import { take } from 'rxjs/operators';

@Component({
    selector: 'shared-form-for-forgot-password',
    templateUrl: './form-for-forgot-password.shared.component.html',
    styleUrls: ['./form-for-forgot-password.shared.component.scss']
})
export class FormForForgotPasswordComponent extends FormTypesComponent implements OnInit {
    constructor(
        @Inject(Tokens.CONFIG_TOKEN) public config: IConfig,
        public formBuilder: FormBuilder,
        public controllers: Controllers,
    ) {
        super(config, formBuilder);
        this.formName = 'forgot-password';
    }

    ngOnInit(): void {
        this.loading$ = this.controllers.members.isMakingRequestsAsStatus$();

        this.formControl = this.formBuilder.group({
            email: [
                { value: '', disabled: false },
                {
                    validators: Validators.compose([
                        Validators.required,
                        Validators.email
                    ]),
                }
            ],
        });
    }

    public handleFormSubmit($event: Event): void {
        const formValues = this.getFormValues();
        this.controllers.members.forgotPasswordResetInit(formValues.email);
    }

    public handleNeedHelpClick($event: Event): void {
        this.controllers.appSettings.contactUsClick();
    }
}
